import { useEffect } from "react";
import {
  handleAuthTokenDrift,
  markTabAuthToken,
  TAB_JWT_KEY,
} from "../auth/tabAuthSync";

const useAuthTabSync = () => {
  useEffect(() => {
    markTabAuthToken();

    const onStorage = (event) => {
      if (event.key !== "jwtToken") {
        return;
      }
      handleAuthTokenDrift();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState !== "visible") {
        return;
      }
      handleAuthTokenDrift();
    };

    window.addEventListener("storage", onStorage);
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      window.removeEventListener("storage", onStorage);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);
};

export default useAuthTabSync;

export { TAB_JWT_KEY };
